import React from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';

export const Button = ({
  children,
  className,
  onClick,
  variant = 'primary',
  size = 'md',
  ...rest
}) => {
  const base =
    'inline-flex items-center justify-center font-semibold tracking-wide border transition-all duration-150 focus:outline-none';

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-5 py-2 text-sm',
    lg: 'px-7 py-3 text-base',
  };

  const styles = {
    primary: 'bg-[#FE5E12] text-white border-black hover:bg-[#e6530f] active:bg-[#cc490d]',

    secondary: 'bg-white text-black border-black hover:bg-black hover:text-white',

    ghost: 'bg-transparent text-black border-black/40 hover:bg-black hover:text-white',

    subtle: 'bg-transparent text-gray-600 border-transparent hover:text-black',
  };

  return (
    <motion.button
      whileTap={{ scale: 0.96 }}
      whileHover={{ y: -1 }}
      className={clsx(
        base,
        sizes[size],
        styles[variant],
        'shadow-[2px_2px_0px_#000]', // newspaper press effect
        'active:shadow-none active:translate-x-[2px] active:translate-y-[2px]',
        className
      )}
      onClick={onClick}
      {...rest}
    >
      {children}
    </motion.button>
  );
};
